/**
 * 钱包充值
 * lixian
 */
const api = [
  {
    name: 'search',
    method: 'GET',
    desc: '查询交易记录',
    path: '/search',
    mock: false
  },
  {
    name: 'audit',
    method: 'POST',
    desc: '中台钱包交易审核',
    path: '/audit',
    mock: false
  },
  {
    name: 'detail',
    method: 'GET',
    desc: '交易记录详情',
    path: '/detail',
    mock: false
  }
]

export default {
  BASE_URL: '/crm/wallet',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/member/wallet.js